import React, { useEffect, useState } from "react";
import {
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Text,
  Tbody,
  Box,
  Grid,
  Input,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalFooter,
  ModalBody,
  useDisclosure,
  useToast,
  Spinner,
  Center,
  VStack,
} from "@chakra-ui/react";
import Title from "../../../components/Title";
import { useNavigate } from "react-router-dom";
import { ProjectType } from "../../../utils/types/cycle";
import { addDataEntry, getDataEntryProjects } from "./dataEntryService";
import FormInput from "../../../components/input";
import DataEntryRow from "../../../components/dataEntryRow";
import { color } from "../../../utils/theme";
const DataEntry = () => {
  const [tableLoading, setTableLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedMeasurmentDataType, setSelectedMeasurmentDataType] =
    useState("");
  const [dataEntryData, setDataEntryDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [dataEntryNumerator, setDataEntryNumerator] = useState("");
  const [dataEntryDenominator, setSetDataEntryDenominator] = useState("");
  const [dataEntryNumber, setDataEntryNumber] = useState("");
  const [dataEntryLoading, setDataEntryLoading] = useState(false);
  const [selectedMeasurment, setSelectedMeasurment] = useState(0);
  const [allProjects, setAllProjects] = useState<ProjectType[]>([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const [filteredProjects, setFilteredProjects] = useState<ProjectType[]>([]);
  const handleEnterDataClicked = (id: number, dataType: string) => {
    console.log(`Data entry clicked for ID: ${id}, Data Type: ${dataType}`);
    // Implement your logic here, such as navigating to another page or setting state
    setSelectedMeasurment(id);
    setSelectedMeasurmentDataType(dataType);
    onOpen();
  };

  const toast = useToast();
  const getAndSetDataEntryProjects = async () => {
    const res = await getDataEntryProjects();
    if (res) {
      const sortedProjects = res.sort((a, b) => a.id - b.id);
      const filtered = sortedProjects.filter((project) =>
        project.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setAllProjects(res);
      setFilteredProjects(filtered);
    }
  };
  useEffect(() => {
    setTableLoading(true);
    getAndSetDataEntryProjects().then(() => {
      setTableLoading(false);
    });
  }, []);
  useEffect(() => {
    console.log("allProjects", allProjects);

    if (searchTerm.toLowerCase() === "") {
      setFilteredProjects(allProjects);
    } else {
      const filtered = filteredProjects.filter((project) =>
        project.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredProjects(filtered);
    }
  }, [searchTerm]);

  return (
    <Box
      display={"flex"}
      h={"100%"}
      w={"100%"}
      flexDirection={"column"}
      justifyContent={"flex-start"}
      alignContent={"center"}
      alignItems={"center"}
      textAlign={"left"}
    >
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add Data</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormInput
              name="dataEntryData"
              isRequired={true}
              value={dataEntryData}
              label="Date"
              type="date"
              id="name"
              errorMessage={""}
              onChange={(event) => {
                setDataEntryDate(event.target.value);
              }}
            />
            {selectedMeasurmentDataType === "Percentage" ? (
              <>
                <FormInput
                  name="numerator"
                  isRequired={true}
                  value={dataEntryNumerator}
                  label="Enter Numerator"
                  type="number"
                  id="numerator"
                  errorMessage={""}
                  onChange={(event) => {
                    setDataEntryNumerator(event.target.value);
                  }}
                />
                <FormInput
                  name="denominator"
                  isRequired={true}
                  value={dataEntryDenominator}
                  label="Enter Denominator"
                  type="text"
                  id="denominator"
                  errorMessage={""}
                  onChange={(event) => {
                    setSetDataEntryDenominator(event.target.value);
                  }}
                />
              </>
            ) : (
              <>
                <FormInput
                  name="number"
                  isRequired={true}
                  value={dataEntryNumber}
                  label="Enter Number"
                  type="text"
                  id="number"
                  onChange={(event) => {
                    setDataEntryNumber(event.target.value);
                  }}
                />
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="blue"
              isLoading={dataEntryLoading}
              mr={3}
              onClick={async () => {
                let result = 0;
                let results = [];
                if (selectedMeasurmentDataType === "Percentage") {
                  result =
                    (parseInt(dataEntryNumerator) /
                      parseInt(dataEntryDenominator)) *
                    100;
                  results = [
                    {
                      result: dataEntryNumerator,
                      result_type: "NUM",
                    },
                    {
                      result: dataEntryDenominator,
                      result_type: "DENOM",
                    },
                  ];
                } else {
                  result = parseInt(dataEntryNumber);
                  results = [
                    {
                      result: dataEntryNumber,
                      result_type: "STRING",
                    },
                  ];
                }
                setDataEntryLoading(true);
                const payload = {
                  measurement_id: selectedMeasurment,
                  result: result,
                  results: results as any[],
                };
                const response = await addDataEntry(payload);
                if (response) {
                  console.log(response.data);
                  setDataEntryLoading(false);
                  onClose();
                  toast({
                    position: "top-right",
                    render: () => (
                      <Box color="white" p={3} bg="green">
                        Data Entered successfully!
                      </Box>
                    ),
                  });
                } else {
                  console.log("something went wrong");
                }
              }}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Grid
        w={"75%"}
        px={"auto"}
        justifyContent={"center"}
        templateColumns={["repeat(1, 1fr)"]}
        gap={[4]}
      >
        <Box style={{ gridColumn: "1 / -1" }}>
          <Title
            title={`Data Entry`}
            onClick={() => {
              navigate("/");
            }}
          />
        </Box>
        <Input
          placeholder="Search a project"
          w={"50%"}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <TableContainer>
          {tableLoading ? (
            <Center h={"100%"}>
              <VStack gap={5}>
                <Spinner mt={10} color={color.primary} />
                <Text>Loading...</Text>
              </VStack>
            </Center>
          ) : (
            <Table variant="simple">
              <Thead>
                <Tr>
                  <Th>#</Th>
                  <Th colSpan={2}>Project</Th>
                  <Th>Measurement</Th>
                  <Th>Cycle</Th>
                  <Th>Actions</Th>
                </Tr>
              </Thead>
              <Tbody>
                {filteredProjects.reverse().map((project, index) => (
                  <DataEntryRow
                    project={project}
                    index={index + 1}
                    onEnterDataClicked={handleEnterDataClicked}
                  />
                ))}
              </Tbody>
            </Table>
          )}
        </TableContainer>
      </Grid>
    </Box>
  );
};
export default DataEntry;
